<!-- <h2>{{ modalTitle }}</h2>
<form #form="ngForm" (ngSubmit)="submitForm(form.value)">
  <div class="mat-form-field">
    <label for="selectedService">Select Service:</label>
    <mat-select name="selectedService" [(ngModel)]="formData.selectedService" required>
      <mat-option *ngFor="let service of getServices()" [value]="service">
        {{service}}
    </mat-option>
    </mat-select>
  </div>
  <div class="mat-form-field">
    <label for="selectedServiceType">Select Service Type:</label>
    <mat-select name="selectedServiceType" [(ngModel)]="formData.selectedServiceType" required>
      <mat-option
              *ngFor="let service_type of getServiceType(formData.get(selectedService)?.value)"
              [value]="service_type">
              {{service_type}}
          </mat-option>
    </mat-select>
  </div>
  <label for="category">Category:</label>
  <input type="text" id="category" name="category" [(ngModel)]="formData.category" required>

  <label for="rated_cost">Rated Cost:</label>
  <input type="text" id="rated_cost" name="rated_cost" [(ngModel)]="formData.rated_cost" required>

  <label for="actual_cost">Actual Cost:</label>
  <input type="text" id="actual_cost" name="actual_cost" [(ngModel)]="formData.actual_cost" required>

  <label for="billable">Billable:</label>
  <input type="text" id="billable" name="billable" [(ngModel)]="formData.billable" required>

  <button type="submit">Submit</button>
</form>
<button (click)="closeModal()">Close</button> -->

<h2>{{ modalTitle }}</h2>
<form [formGroup]="serviceForm" (ngSubmit)="submitForm()">
  <div class="modal-form">
    <div class="column">
      <div class="mat-form-field">
        <mat-form-field>
          <mat-label>Selected Service:</mat-label>
          <mat-select formControlName="selectedService">
            <mat-option *ngFor="let service of getServices()" [value]="service">
              {{ service }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="mat-form-field">
        <mat-form-field>
          <mat-label>Selected Service Type:</mat-label>
          <mat-select formControlName="selectedServiceType">
            <mat-option *ngFor="let service_type of getServiceType(serviceForm.get('selectedService')?.value)"
              [disabled]="!serviceForm.get('selectedService')?.value"
              [value]="service_type">
              {{ service_type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="column">

      <mat-form-field>
        <mat-label for="rated_cost">Rated Cost:</mat-label>
        <input matInput type="text" id="rated_cost" formControlName="rated_cost">
      </mat-form-field>
      <br>

      <mat-form-field>
        <mat-label for="actual_cost">Actual Cost:</mat-label>
        <input matInput type="text" id="actual_cost" formControlName="actual_cost">
      </mat-form-field>
      <br>

      <mat-form-field>
        <mat-label for="billable">Billable:</mat-label>
        <input matInput type="text" id="billable" formControlName="billable">
      </mat-form-field>

    </div>

  </div>
</form>


<div class="buttons">
  <button mat-raised-button color="primary" [disabled]="serviceForm.invalid" (click)="submitForm()">Submit</button>
  <button mat-raised-button color="primary" (click)="closeModal()">Close</button>
</div>